<template>
  <div id="app">
    <div class="bg-under"></div>
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
window.onload = function() {
  // 阻止双击放大行为
  var lastTouchEnd = 0;
  document.addEventListener("touchstart", function(event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener(
    "touchend",
    function(event) {
      var now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );

  // 阻止双指进行缩放大行为
  document.addEventListener("gesturestart", function(event) {
    event.preventDefault();
  });
};
export default {
  created() {
    axios.get("https://geoip.transit.finance/").then((res) => {
      if (
        res.status === 200 &&
        res.data.compliant_area
      ) {
        history.pushState({}, "");
        window.location = "https://swap.transit.finance/region/index.html";
      }
    });
  },
};
</script>
<style lang="less"></style>
